import { render } from "./EditNews.vue?vue&type=template&id=4842d842&scoped=true"
import script from "./EditNews.vue?vue&type=script&lang=js"
export * from "./EditNews.vue?vue&type=script&lang=js"

import "./EditNews.vue?vue&type=style&index=0&id=4842d842&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4842d842"]])

export default __exports__